const raw = localStorage.getItem("patientData");

// parse, falling back to an empty object if nothing’s there
// export const patientDetails = raw ? JSON.parse(raw) : {};
// export const patientDetails = {
//   Gender:"male",
//   age:21
// }

const patientDetails = raw ? JSON.parse(raw) : null;

// utils/testCategoryMap.js (you can keep this in a utils folder)
export const TEST_CATEGORY_MAP = {
  BO: "Body Analysis",
  CT: "Cancer Test",
  CO: "Cough Analysis",
  EN: "ENT",
  ST: "Stethoscope Amplifier",
  LP: "Lipid Profile", // Correct: Lipid Profile
  CA: "Cardiac",
  HO: "Hormonal", // Correct: Hormonal
  IN: "Infection Marker", // Correct: Infection Marker
  DI: "Diabetic",
  RE: "Respiratory", // Correct: Respiratory
  VE: "Vector Borne",
  BL: "Blood Marker",
  KI: "Kidney Marker",
  LI: "Liver Marker", // Correct: Liver Marker
  OT: "Other Test",
};

export const TEST_SELECTION_MAP = {
  BO: "Body Analysis",
  // CT: "Cancer Test",
  CO: "AI Analysis",
  EN: "AI Analysis",
  ST: "AI Analysis",
  // LP: "Cardiac", // Correct: Lipid Profile
  CA: "Cardiac",
  HO: "Hormonal", // Correct: Hormonal
  IN: "Infection Marker", // Correct: Infection Marker
  DI: "Diabetic",
  RE: "Respiratory", // Correct: Respiratory
  VE: "Vector Borne",
  BL: "Blood Marker",
  KI: "Kidney Marker",
  LI: "Liver Marker", // Correct: Liver Marker
  OT: "Other Test",
};
export const HIDDEN_TEST_ID = [
  "KI0869",
  "LI1517",
  "KI6501",
  "KI9413",
  "KI5376",
  "KI9527",
  "KI7425",
  "LI3146",
  "LI7617",
];

export const COUPLED_TESTS = [
  {
    ids: ["OT1861", "OT8141"],
    name: "Typhoid (IgM + IgG)",
    category: "Other Test",
  },
  {
    ids: ["OT2118", "OT9164"],
    name: "Cholera Ag",
    category: "Other Test",
  },
  {
    ids: ["OT5754", "OT4134"],
    name: "Chikungunya IgM/IgG",
    category: "Other Test",
  },
  {
    ids: ["OT1059", "OT4073"],
    name: "Leptospira IgM/IgG",
    category: "Other Test",
  },
  {
    ids: ["OT0999", "OT8255"],
    name: "HIV Antibody",
    category: "Other Test",
  },
  {
    ids: ["OT0783", "OT8637"],
    name: "Scrub Typhus IgM/IgG",
    category: "Other Test",
  },
  {
    ids: ["OT9641", "OT0641", "OT7160"],
    name: "Maleria pf PAN Ag",
    category: "Other Test",
  },
  {
    ids: ["OT0641", "OT7164"],
    name: "Maleria Pf/Pv Ag",
    category: "Other Test",
  },
  {
    ids: ["OT2048", "OT0575", "OT8482"],
    name: "Syphillis Antibody",
    category: "Other Test",
  },
  {
    ids: ["OT1811", "OT3582", "OT2194"],
    name: "Dengue Duo - Ag + Ab",
    category: "Other Test",
  },
  {
    ids: [
      "BO7972",
      "BO0608",
      "BO6682",
      "BO5977",
      "BO6603",
      "BO6353",
      "BO8701",
      "BO6881",
      "BO8158",
      "BO4978",
      "BO3857",
      "BO2540",
      "BO5644",
    ],
    name: "General Test",
    category: "Body Analysis",
  },
  {
    ids: [
      "BL5751",
      "BL6013",
      "BL9029",
      "BL8302",
      "BL8616",
      "BL9859",
      "BL4874",
      "BL6352",
      "BL9729",
      "BL8396",
      "BL8183",
      "BL1048",
      "BL6891",
      "BL6674",
      "BL6608",
      "BL4053",
      "BL6464",
      "BL7481",
      "BL6036",
      // "BL6036",
      "BL6889",
      "BL2185",
      "BL4640",
    ],
    name: "Complete Blood Marker",
    category: "Blood Marker",
  },

  {
    ids: [
      "KIU7412",
      "KIU1513",
      "KIU5853",
      "KIU5691",
      "KIU4330",
      "KIU0121",
      "KIU5213",
      "KIU8382",
      "KIU4022",
      "KIU5349",
      "KIU6268",
    ],
    name: "Routine Panel",
    category: "Kidney Marker",
  },

  {
    ids: ["KIU6626", "KIU1502"],
    name: "Urine Creatine + Microalbumin",
    category: "Kidney Marker",
  },

  {
    ids: ["DI9336", "DI6658"],
    name: "HbA1c",
    category: "Diabetic",
  },

  {
    ids: ["KI5936", "KI0869", "KI7425"],
    name: "Creatinine",
    category: "Kidney Marker",
  },
  // {
  //   ids:["BL9030"],
  //   name:'Hemoglobin',
  //   category:"Blood Marker"
  // }
  // {
  //   ids: ["LP0288", "LP4466", "LP8351", "LP4115", "LP5121", "LP7013"],
  //   name: "Lipid Profile",
  //   category: "Cardiac",
  // },
  // {
  //   ids :[
  //     "GE2498",
  //     "GE5694",
  //     "GE9357",
  //     "GE0399",
  //     "GE4914",
  //     "GE8523",
  //     "GE8161",
  //     "GE6942",
  //     "GE3903",
  //     "GE6483",
  //     "GE4000",
  //     "GE3153",
  //     "GE9503",
  //     "GE9223",
  //     "GE2800",
  //     "GE9782",
  //     "GE4761",
  //     "GE6172"
  //   ],
  //   name :"Cough Analysis",
  //   category:"AI Analysis"

  // }
  // {
  //   ids: [
  //     "LI6534",
  //     "LI5192",
  //     "LI5902",
  //     "LI2429",
  //     "LI8253",
  //     "LI0218",
  //     "LI6559",
  //     "LI7617",
  //     "LI1947",
  //     "LI3146",
  //     "LI1517",
  //   ],
  //   name: "Complete Liver Functions",
  //   category: "Liver Marker",
  // },
  // {
  //   ids:["KI8734","KI3990","KI3384","KI2682","KI5836","KI5376","KI9527","KI0036","KI9413","KI6501","KI0869","KI7425","KI5046","KI4849"],
  //   name:"Complete Renal Profile",
  //   category:"Kidney Marker"
  // }
];

export const DEPENDENT_TESTS = [
  {
    name: "Complete Renal Profile",
    ids: [
      "KI8734", // Urea
      "KI3990", // Uric Acid
      "KI3384", // Sodium
      "KI2682", // Potassium
      "KI5836", // Total Protein
      "KI0036", // Albumin
      "KI5046", // Chloride
      "KI4849", // Calcium
      "KI5936", // Creatinine
      "KI0283", // Phosphorous
      "KI7425", // GFR Category
      "KI9413", // Globulin
      "KI0869", // Estimated GFR
      "KI6501", // Ratio Albumin: Globulin
      "KI9527", // Ratio BUN: Creatinine
      "KI5376", // Blood Urea Nitrogen
    ],

    category: "Kidney Marker",
  },
  {
    name: "Complete Liver Function Tests",
    ids: [
      "LI6534",
      "LI5902",
      "LI2429",
      "LI8253",
      "LI5192",
      "LI0218",
      "LI6559",
      "LI1947",
      "LI7617",
      "LI3146",
      "LI1517",
    ],
    category: "Liver Marker",
  },
  {
    ids: ["LP0288", "LP4466", "LP8351", "LP4115", "LP7013" , "LP5121"],
    name: "Lipid Profile",
    category: "Cardiac",
  },

  {
    ids: ["BL9030"],
    name: "Hemoglobin",
    category: "Blood Marker",
  },

  {
    ids: ["HO5427", "HO9882", "HO0972"],
    name: "Thyroid Profile",
    category: "Hormonal",
  },

  // you can add more masters here
];

export const CALCULATED_TESTS = {
  DI6658: {
    dependsOn: ["DI9336"],
    formula: (vals) => (28.7 * Number(vals.DI9336) - 46.7).toFixed(2),
  },
  KI5691: {
    dependsOn: ["KI0121", "KI5213"],
    formula: (vals) => {
      const a = Number(vals.KI0121) || 0;
      const b = Number(vals.KI5213) || 0;
      return ((a + b) / 2).toFixed(2);
    },
  },
  KI5376: {
    dependsOn: ["KI8734"],
    formula: (vals) => {
      const a = Number(vals.KI8734) || 0;
      return (a / 2.14).toFixed(2);
    },
  },
  KI9527: {
    dependsOn: ["KI5376", "KI5936"],
    formula: (vals) => {
      const a = Number(vals.KI5376) || 0;
      const b = Number(vals.KI5936) || 0;
      return b !== 0 ? (a / b).toFixed(2) : "";
    },
  },
  LI3146: {
    dependsOn: ["LI1947", "LI6559"],
    formula: (vals) => {
      const a = Number(vals.LI1947) || 0;
      const b = Number(vals.LI6559) || 0;
      return a !== 0 ? (b - a ).toFixed(2) : "";
    },
  },
  LI1517: {
    dependsOn: ["LI1947", "LI3146"],
    formula: (vals) => {
      const a = Number(vals.LI1947) || 0;
      const b = Number(vals.LI3146) || 0;
      return (a / b).toFixed(2);
    },
  },
  // KI9413: {
  //   dependsOn: ["KI5836", "KI0036"],
  //   formula: (vals) => {
  //     const a = Number(vals.KI5836) || 0;
  //     const b = Number(vals.KI0036) || 0;
  //     const result = a - b;
  //     return String(result);
  //   },
  // },

  KI6501: {
    dependsOn: ["KI0036", "KI9413"],
    formula: (vals) => {
      const a = Number(vals.KI0036) || 0;
      const b = Number(vals.KI9413) || 0;
      return b !== 0 ? (a / b).toFixed(2) : "";
    },
  },
  KI0869: {
    dependsOn: ["KI5936"],
    formula: (vals) => {
      // 1. read the input value
      const creatinine = Number(vals.KI5936);

      // 2. safely pull gender & age
      const genderRaw = patientDetails.Gender.toLowerCase();

      const age = Number(patientDetails.Age);

      // 3. set constants based on gender (default to male)
      let kappa = 0.9,
        alpha = -0.302,
        genderMultiplier = 1;
      if (genderRaw === "female") {
        kappa = 0.7;
        alpha = -0.241;
        genderMultiplier = 1.012;
      }

      // 4. compute the CKD‑EPI parts
      const scrOverK = creatinine / kappa;
      const minPart = Math.min(scrOverK, 1) ** alpha;
      const maxPart = Math.max(scrOverK, 1) ** -1.2;
      const ageFactor = Math.pow(0.9938, age);

      // 5. final eGFR
      const eGFR = 142 * minPart * maxPart * ageFactor * genderMultiplier;

      // 6. return as fixed‑two‑decimals string
      return eGFR.toFixed(2);
    },
  },
  KI7425: {
    dependsOn: ["KI0869"],
    formula: (vals) => {
      const egfrStr = vals.KI0869;
      const val = parseFloat(egfrStr);
      if (isNaN(val)) {
        console.error("Invalid eGFR value:", egfrStr);
        return "";
      }

      let gfrCategory;
      if (val >= 90) gfrCategory = "G1: Normal";
      else if (val >= 60) gfrCategory = "G2: Mild decrease";
      else if (val >= 45) gfrCategory = "G3a: Mild to moderate";
      else if (val >= 30) gfrCategory = "G3b: Moderate to severe";
      else if (val >= 15) gfrCategory = "G4: Severe";
      else gfrCategory = "G5: Kidney failure";

      return gfrCategory;
    },
  },
  LI7617: {
    dependsOn: ["LI5192", "LI0218"],
    formula: (vals) => {
      const a = Number(vals.LI5192) || 0;
      const b = Number(vals.LI0218) || 0;
      return (a - b).toFixed(2);
    },
  },
  LP5121: {
    dependsOn: ["LP8351", "LP4115"],
    formula: (vals) => {
      const a = Number(vals.LP8351) || 0;
      const b = Number(vals.LP4115) || 0;
      return b !== 0 ? (a / b).toFixed(2) : "";
    },
  },

  KI9413: {
    dependsOn: ["KI5836", "KI0036"],
    formula: (vals) => {
      const a = Number(vals.KI5836) || 0;
      const b = Number(vals.KI0036) || 0;
      return (a - b).toFixed(2);
    },
  },
};

// Hide dependent auto-calculated tests when their prerequisite test
// is missing from the current selection (e.g., hide LI1517 if LI3146
// is not present).
export const filterTestsForDisplay = (tests = []) => {
  const list = Array.isArray(tests) ? tests : [];
  const allIds = new Set();

  list.forEach((group) => {
    (group?.options || []).forEach((opt) => {
      const id = opt?.ParameterID;
      if (id) allIds.add(id);
    });
  });

  const shouldHide = (id) => id === "LI1517" && !allIds.has("LI3146");

  return list
    .map((group) => ({
      ...group,
      options: Array.isArray(group?.options)
        ? group.options.filter((opt) => !shouldHide(opt?.ParameterID))
        : [],
    }))
    .filter((group) => Array.isArray(group.options) && group.options.length > 0);
};
